import React, { FC, useLayoutEffect } from 'react';

import useFeatureFlagOnce from '../hooks/useFeatureFlagOnce';
import { initializeServiceWorker } from '../utils/runtime';

const FEATURE_FLAG_NAME = 'acc-exo-skeleton-service-worker';

export const ServiceWorkerContainer: FC = ({ children }) => {
  const { value, loading } = useFeatureFlagOnce(FEATURE_FLAG_NAME, false);

  useLayoutEffect(() => {
    if (!loading) {
      initializeServiceWorker({
        disabled: !value,
      });
    }
  }, [loading, value]);

  return <>{children}</>;
};
